import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5596e09e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "monitor-container" }
const _hoisted_2 = { class: "head clearfix" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "pulll_left" }, "大数据监控平台", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu menu2 pulll_left" }, null, -1))
const _hoisted_5 = {
  class: "time flip-clock",
  id: "showTime"
}
const _hoisted_6 = ["onTransitionend"]
const _hoisted_7 = { class: "flip-card-front" }
const _hoisted_8 = { class: "flip-card-back" }
const _hoisted_9 = { class: "mainbox" }
const _hoisted_10 = { class: "clearfix nav1" }
const _hoisted_11 = { style: {"width":"22%"} }
const _hoisted_12 = { class: "box" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tit" }, "站点排名", -1))
const _hoisted_14 = {
  class: "boxnav",
  style: {"height":"200px","overflow-y":"scroll"}
}
const _hoisted_15 = {
  class: "table1",
  width: "100%",
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_16 = { class: "text-w" }
const _hoisted_17 = { class: "text-b" }
const _hoisted_18 = { class: "box" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tit" }, "设备运行状态", -1))
const _hoisted_20 = {
  class: "boxnav",
  style: {"height":"250px"}
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "",
  style: {"height":"190px"},
  id: "echart1"
}, null, -1))
const _hoisted_22 = { class: "leidanav" }
const _hoisted_23 = { class: "clearfix" }
const _hoisted_24 = { style: {"width":"56%"} }
const _hoisted_25 = { class: "box" }
const _hoisted_26 = {
  class: "boxnav mapc",
  style: {"height":"550px","position":"relative"}
}
const _hoisted_27 = { class: "mapnav" }
const _hoisted_28 = { class: "mapnav2" }
const _hoisted_29 = { class: "box" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tit" }, "今日订单趋势", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "boxnav",
  style: {"height":"130px"},
  id: "sysx"
}, null, -1))
const _hoisted_32 = {
  class: "leidanav leidanav3",
  style: {"margin-bottom":"15px"}
}
const _hoisted_33 = { class: "clearfix" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "总订单", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "总电量", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "总电费", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "总服务费", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "map",
  id: "map"
}, null, -1))
const _hoisted_39 = { style: {"width":"22%"} }
const _hoisted_40 = { class: "box" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tit" }, "用户统计", -1))
const _hoisted_42 = {
  style: {"height":"300px"},
  class: "box-user"
}
const _hoisted_43 = { class: "box-user-valute" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "总用户", -1))
const _hoisted_45 = { class: "value" }
const _hoisted_46 = /*#__PURE__*/_createStaticVNode("<div class=\"box-user-valute\" data-v-5596e09e><div style=\"width:50%;text-align:center;\" data-v-5596e09e><div class=\"title\" data-v-5596e09e>月活跃</div><div style=\"width:200px;height:200px;\" id=\"fb03\" data-v-5596e09e></div></div><div style=\"width:50%;text-align:center;\" data-v-5596e09e><div class=\"title\" data-v-5596e09e>日活跃</div><div style=\"width:200px;height:200px;\" id=\"fb04\" data-v-5596e09e></div></div></div>", 1)
const _hoisted_47 = { class: "box" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tit" }, "节能减排统计", -1))
const _hoisted_49 = {
  style: {"height":"150px"},
  class: "box-value co2-content"
}
const _hoisted_50 = { class: "box-user-valute" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "二氧化碳减排:", -1))
const _hoisted_52 = { class: "value" }
const _hoisted_53 = { class: "box-user-valute" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "相当于植树量:", -1))
const _hoisted_55 = { class: "value" }
const _hoisted_56 = {
  class: "box",
  style: {"padding":"20px 0"}
}
const _hoisted_57 = { class: "clearfix nav2" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { style: {"width":"50%"} }, [
  /*#__PURE__*/_createElementVNode("div", { class: "tit01" }, "近12个月趋势"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "ftechart",
    id: "echart4"
  })
], -1))
const _hoisted_59 = { style: {"width":"50%"} }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tit01" }, "昨日充电汇总(昨日与前一天的对比增长)", -1))
const _hoisted_61 = { class: "yesterday-data" }
const _hoisted_62 = { class: "yesterday-charge-data" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "昨日充电金额(元)", -1))
const _hoisted_64 = { class: "value" }
const _hoisted_65 = /*#__PURE__*/_createTextVNode(" 环比:")
const _hoisted_66 = { class: "yesterday-charge-data" }
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "昨日充电时长(小时)", -1))
const _hoisted_68 = { class: "value" }
const _hoisted_69 = /*#__PURE__*/_createTextVNode(" 环比:")
const _hoisted_70 = { class: "yesterday-charge-data" }
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "昨日充电度数(度)", -1))
const _hoisted_72 = { class: "value" }
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" 环比:")
const _hoisted_74 = { class: "yesterday-charge-data" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "昨日充电次数(次)", -1))
const _hoisted_76 = { class: "value" }
const _hoisted_77 = /*#__PURE__*/_createTextVNode(" 环比:")

import { ref, onMounted, nextTick, computed, watch, Ref } from 'vue'
import * as echarts from 'echarts'
import type { EChartsOption, EChartsType } from 'echarts'
import chinaMap from '@/assets/maps/china.json' // Adjust path if needed
import { useChartData } from '@/views/DataV/useChartData'
import { stationData } from './test'
// import PercentageCircle from './components/PercentageCircle.vue'

import { onUnmounted } from 'vue'
import { EvseOrderStatistics } from '@/types/cms/user'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const currentTime = ref('')
let timeUpdateTimeout: number | null = null

const showDigits = ref<string[]>([])
const nextDigits = ref<string[]>([])
const flipFlags = ref<boolean[]>([])
const sysxChart = ref<EChartsType>()
const echart1 = ref<EChartsType>()
const chartMap = ref<EChartsType>()
const chartFB3 = ref<EChartsType>()
const chartFB4 = ref<EChartsType>()
const myChart4 = ref<EChartsType>()
const currentTimeDigits = computed(() => currentTime.value.split(''))
const {
  totalListData,
  hour24Trend,
  hour24Total,
  totalEvseStatus,
  stationList,
  stationMap,
  parcent,
  yesterdayTotal,
  co2EmissionReductionValue,
  plantingTreeValue,
  userStat,
  month12TredTotal,
} = useChartData()
watch(month12TredTotal, () => {
  if (!myChart4.value) return
  const cols = ['#5e4eff', '#2f89cf', '#4cb9cf', '#e0c828', '#e58c00', '#eb295b']
  myChart4.value.setOption({
    xAxis: [
      {
        data: month12TredTotal.value.xAxisData,
      },
    ],
    series: month12TredTotal.value.legendData.map((item, index) => ({
      name: item,
      type: 'line',
      smooth: true,
      data: month12TredTotal.value.seriesData[index],
      itemStyle: {
        normal: {
          color: cols[index],
          opacity: 1,
          barBorderRadius: 5,
        },
      },
    })),
    legend: {
      data: month12TredTotal.value.legendData,
    },
  })
  console.log(myChart4.value)
})
watch(userStat, () => {
  if (!chartFB4.value || !chartFB3.value) {
    return
  }
  chartFB3.value.setOption({
    series: [
      {
        color: ['#e58c00', '#eb295b'],
        data: [
          {
            value: userStat.value.actNumByMon ?? 0,
            name: '月活数量',
          },
          {
            value: userStat.value.totalNum,
            name: '用户总数',
          },
        ],
      },
    ],
  })
  chartFB4.value.setOption({
    series: [
      {
        color: ['#5e4eff', '#e0c828', '#e58c00', '#eb295b'],

        data: [
          {
            value: userStat.value.actNumByDay ?? 0,
            name: '日活数量',
          },
          {
            value: userStat.value.totalNum,
            name: '用户总数',
          },
        ],
      },
    ],
  })
})
watch(
  currentTimeDigits,
  (newVal, oldVal) => {
    if (!oldVal || oldVal.length === 0) {
      showDigits.value = [...newVal]
      nextDigits.value = [...newVal]
      flipFlags.value = newVal.map(() => false)
      return
    }
    newVal.forEach((digit, idx) => {
      if (digit !== oldVal[idx]) {
        nextDigits.value[idx] = digit
        flipFlags.value[idx] = true
      }
    })
  },
  { immediate: true },
)
watch(
  () => stationMap.value,
  (newVal) => {
    if (!chartMap.value) return
    const data = (newVal ?? []).map((i) => {
      return {
        name: i.stationName,
        value: [i.lng, i.lat, i.evseNum],
      }
    })
    chartMap.value.setOption({
      series: [
        {
          data: data,
        },
      ],
    })
    console.log('stationMap', data)
  },
)
// 监听 hour24Trend 的变化
watch(
  () => hour24Trend.value,
  (newVal) => {
    if (!sysxChart.value) return

    sysxChart.value.setOption({
      xAxis: [
        {
          data: newVal?.xAxis ?? [],
        },
      ],
      series: [
        {
          data: newVal?.data ?? [],
        },
      ],
    })
  },
  { deep: true },
)
watch(
  () => totalEvseStatus.value,
  (newVal) => {
    if (!echart1.value) return

    echart1.value.setOption({
      legend: [
        {
          data: newVal?.map((item) => item.name) ?? [],
        },
      ],
      series: [
        {
          data: newVal ?? [],
        },
      ],
    })
  },
  { deep: true },
)
function onFlipEnd(idx: number) {
  showDigits.value[idx] = nextDigits.value[idx]
  flipFlags.value[idx] = false
}

onMounted(() => {
  showDigits.value = currentTime.value.split('')
  nextDigits.value = currentTime.value.split('')
  flipFlags.value = currentTime.value.split('').map(() => false)
})

const charts: EChartsType[] = []

function updateTime() {
  if (timeUpdateTimeout) clearTimeout(timeUpdateTimeout)
  const dt = new Date()
  const y = dt.getFullYear()
  const mt = dt.getMonth() + 1
  const day = dt.getDate()
  const h = dt.getHours()
  const m = dt.getMinutes()
  const s = dt.getSeconds()
  // 补零格式化
  function pad(n: number) {
    return n < 10 ? '0' + n : n
  }
  currentTime.value = `${pad(h)}:${pad(m)}:${pad(s)}`
  timeUpdateTimeout = window.setTimeout(updateTime, 1000)
}

function initEchart1() {
  const chartDom = document.getElementById('echart1')
  if (!chartDom) return
  echart1.value = echarts.init(chartDom)
  charts.push(echart1.value)
  const option: EChartsOption = {
    tooltip: { trigger: 'item', formatter: '{a} <br/>{b} : {c} ({d}%)' },
    legend: {
      itemWidth: 10,
      itemHeight: 10,
      itemGap: 10,
      data: [],
      textStyle: { color: 'rgba(255,255,255,.5)', fontSize: '12' },
    },
    series: [
      {
        name: '类型',
        type: 'pie',
        radius: ['10%', '60%'],
        center: ['50%', '50%'],
        roseType: 'radius',
        color: ['#5e4eff', '#2f89cf', '#eb0012', '#e0c828', '#e58c00'],
        data: totalEvseStatus.value ?? [],
        label: { show: true, fontSize: 10 },
        labelLine: { show: true, length: 5, length2: 5 },
      },
    ],
  }
  echart1.value.setOption(option)
}

function initMap() {
  const chartDom = document.getElementById('map')
  if (!chartDom) return
  chartMap.value = echarts.init(chartDom)
  charts.push(chartMap.value)

  // Register the China map
  echarts.registerMap('china', chinaMap as any)

  const option: EChartsOption = {
    title: {
      text: '',
      subtext: '',
      sublink: '',
      left: 'center',
      textStyle: { color: '#fff' },
    },
    tooltip: {
      trigger: 'item',
      formatter: (params) => {
        return `名称:${params.name}<br/>充电桩数量:${
          Array.isArray(params.value) ? params.value[2] : ''
        }`
      },
    },
    geo: {
      map: 'china',
      label: { emphasis: { show: false } },
      roam: false,
      zoom: 1.2,
      itemStyle: {
        normal: {
          areaColor: 'rgba(2,37,101,.5)',
          borderColor: 'rgba(94, 78, 255,.5)',
        },
        emphasis: { areaColor: 'rgba(2,37,101,.8)' },
      },
    },
    series: [
      {
        name: '站点',
        type: 'scatter',
        coordinateSystem: 'geo',
        data: [],
        symbolSize: (val: number[]) => val[2] / 10 || 5,
        label: {
          normal: {
            formatter: (value: string[]) => {
              return ''
            },
            position: 'right',
            show: false,
          },
          emphasis: { show: true },
        },
        itemStyle: { normal: { color: '#fa0454' } },
      },
    ],
  }
  chartMap.value.setOption(option)
}

function initEchart3_4() {
  // const chartDom3 = document.getElementById('echart3')
  const chartDom4 = document.getElementById('echart4')

  // if (chartDom3) {
  //   const myChart3 = echarts.init(chartDom3)
  //   charts.push(myChart3)
  //   const option3: EChartsOption = {
  //     // option from echarts_4 for echart3
  //     tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
  //     legend: {
  //       data: ['文本1', '文本2'],
  //       top: '2%',
  //       textStyle: { color: 'rgba(255,255,255,.5)', fontSize: '12' },
  //       itemWidth: 12,
  //       itemHeight: 12,
  //       itemGap: 35,
  //     },
  //     grid: {
  //       left: '0%',
  //       top: '40px',
  //       right: '0%',
  //       bottom: '0%',
  //       containLabel: true,
  //     },
  //     xAxis: [
  //       {
  //         type: 'category',
  //         data: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
  //         axisLine: {
  //           show: true,
  //           lineStyle: {
  //             color: 'rgba(255,255,255,.1)',
  //             width: 1,
  //             type: 'solid',
  //           },
  //         },
  //         axisTick: { show: false },
  //         axisLabel: {
  //           interval: 0,
  //           show: true,
  //           splitNumber: 15,
  //           textStyle: { color: 'rgba(255,255,255,.6)', fontSize: '14' },
  //         },
  //       },
  //     ],
  //     yAxis: [
  //       {
  //         type: 'value',
  //         axisLabel: {
  //           show: true,
  //           textStyle: { color: 'rgba(255,255,255,.6)', fontSize: '14' },
  //         },
  //         axisTick: { show: false },
  //         axisLine: {
  //           show: true,
  //           lineStyle: {
  //             color: 'rgba(255,255,255,.1)',
  //             width: 1,
  //             type: 'solid',
  //           },
  //         },
  //         splitLine: { lineStyle: { color: 'rgba(255,255,255,.1)' } },
  //       },
  //     ],
  //     series: [
  //       {
  //         name: '文本1',
  //         type: 'bar',
  //         data: [2, 3, 3, 9, 15, 12, 6, 4, 6],
  //         barWidth: '20%',
  //         itemStyle: {
  //           normal: { color: '#2f89cf', opacity: 1, barBorderRadius: 5 },
  //         },
  //       },
  //       {
  //         name: '文本2',
  //         type: 'bar',
  //         data: [1, 4, 5, 11, 12, 9, 5, 6, 5],
  //         barWidth: '20%',
  //         itemStyle: {
  //           normal: { color: '#62c98d', opacity: 1, barBorderRadius: 5 },
  //         },
  //       },
  //     ],
  //   }
  //   myChart3.setOption(option3)
  // }

  if (chartDom4) {
    myChart4.value = echarts.init(chartDom4)
    charts.push(myChart4.value)
    const option4: EChartsOption = {
      // option2 from echarts_4 for echart4
      tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
      legend: {
        data: ['2017年', '2018年'],
        top: '5%',
        textStyle: { color: '#fff', fontSize: '12' },
        itemGap: 35,
      },
      grid: {
        left: '0%',
        top: '40px',
        right: '0%',
        bottom: '0',
        containLabel: true,
      },
      xAxis: [
        {
          type: 'category',
          data: [],
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,.1)',
              width: 1,
              type: 'solid',
            },
          },
          axisTick: { show: false },
          axisLabel: {
            interval: 0,
            show: true,
            splitNumber: 5,
            textStyle: { color: 'rgba(255,255,255,.6)', fontSize: '12' },
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            show: true,
            textStyle: { color: 'rgba(255,255,255,.6)', fontSize: '12' },
          },
          axisTick: { show: false },
          axisLine: {
            show: true,
            lineStyle: {
              color: 'rgba(255,255,255,.1)',
              width: 1,
              type: 'solid',
            },
          },
          splitLine: { lineStyle: { color: 'rgba(255,255,255,.1)' } },
        },
      ],
      series: [
        {
          name: '2017年',
          type: 'line',
          smooth: true,
          data: [2, 6, 3, 8, 5, 8],
          itemStyle: {
            normal: { color: '#2f89cf', opacity: 1, barBorderRadius: 5 },
          },
        },
        {
          name: '2018年',
          type: 'line',
          smooth: true,
          data: [5, 2, 6, 4, 5, 12],
          itemStyle: {
            normal: { color: '#62c98d', opacity: 1, barBorderRadius: 5 },
          },
        },
      ],
    }
    myChart4.value.setOption(option4)
  }
}

function initPieChart(
  elementId: string,
  name: string,
  data: { value: number; name: string }[],
  legendData: string[],
  refdata: Ref<EChartsType | undefined>,
) {
  const chartDom = document.getElementById(elementId)
  if (!chartDom) return
  refdata.value = echarts.init(chartDom)
  charts.push(refdata.value)
  const option: EChartsOption = {
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)',
      position: (p: number[]) => [p[0] + 10, p[1] - 10],
    },
    // legend: {
    //   orient: 'vertical',
    //   top: elementId === 'fb01' || elementId === 'fb03' ? '25%' : 'center',
    //   right: elementId === 'fb01' || elementId === 'fb03' ? 0 : '8%',
    //   itemWidth: 10,
    //   itemHeight: 10,
    //   data: legendData,
    //   textStyle: { color: 'rgba(255,255,255,.5)', fontSize: '12' },
    // },
    series: [
      {
        name: name,
        type: 'pie',
        center: ['50%', '50%'],
        radius: ['40%', '50%'],
        color: ['#62c98d', '#2f89cf', '#4cb9cf', '#e0c828', '#e58c00', '#eb295b'],
        label: { show: false },
        labelLine: { show: false },
        data: data,
      },
    ],
  }
  refdata.value.setOption(option)
}

function initFbCharts() {
  initPieChart(
    'fb03',
    '月统计',
    [
      { value: 4, name: '数据分门别类' },
      { value: 2, name: '数据关系部门' },
      { value: 2, name: '今日数据交易' },
    ],
    [],
    chartFB3,
  )
  initPieChart(
    'fb04',
    '周统计',
    [
      { value: 4, name: '数据分门别类' },
      { value: 2, name: '数据关系部门' },
      { value: 2, name: '今日数据交易' },
    ],
    [],
    chartFB4,
  )
}

function initMyd1Chart() {
  const chartDom = document.getElementById('myd1')
  if (!chartDom) return
  const myChart = echarts.init(chartDom)
  charts.push(myChart)
  const option: EChartsOption = {
    grid: { left: '0', right: '0', top: '10%', bottom: '24%' },
    legend: {
      data: ['等待', '已办人数', '已办业务'],
      bottom: 0,
      itemWidth: 10,
      itemHeight: 10,
      textStyle: { color: '#fff', fontSize: '10' },
      itemGap: 5,
    },
    tooltip: { show: true, trigger: 'item' },
    yAxis: { type: 'value', show: false },
    xAxis: [
      {
        type: 'category',
        axisTick: { show: false },
        axisLine: { show: true, lineStyle: { color: '#363e83' } },
        axisLabel: {
          show: false,
          textStyle: {
            color: 'rgba(255,255,255,1)',
            fontWeight: 'normal',
            fontSize: '12',
          },
        },
        data: ['业务办量统计'],
      },
    ],
    series: [
      {
        name: '等待',
        type: 'bar',
        barWidth: '20',
        itemStyle: {
          normal: {
            show: true,
            color: '#20aa92',
            barBorderRadius: 50,
            borderWidth: 0,
          },
        },
        zlevel: 2,
        barGap: '100%',
        data: [20],
        label: {
          formatter: '{c}人',
          show: true,
          position: 'top',
          textStyle: { fontSize: 12, color: 'rgba(255,255,255,.6)' },
        },
      },
      {
        name: '已办人数',
        type: 'bar',
        itemStyle: {
          normal: {
            show: true,
            color: '#f4664e',
            barBorderRadius: 50,
            borderWidth: 0,
          },
        },
        zlevel: 2,
        barWidth: '20',
        data: [40],
        label: {
          formatter: '{c}人',
          show: true,
          position: 'top',
          textStyle: { fontSize: 12, color: 'rgba(255,255,255,.6)' },
        },
      },
      {
        name: '已办业务',
        type: 'bar',
        itemStyle: {
          normal: {
            show: true,
            color: '#0c93dc',
            barBorderRadius: 50,
            borderWidth: 0,
          },
        },
        zlevel: 2,
        barWidth: '20',
        data: [127],
        label: {
          formatter: '{c}份',
          show: true,
          position: 'top',
          textStyle: { fontSize: 12, color: 'rgba(255,255,255,.6)' },
        },
      },
    ],
  }
  myChart.setOption(option)
}

function initSysxChart() {
  const chartDom = document.getElementById('sysx')
  if (!chartDom) return
  sysxChart.value = echarts.init(chartDom)
  charts.push(sysxChart.value)
  const option: EChartsOption = {
    tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' } },
    grid: {
      left: '0%',
      top: '10px',
      right: '0%',
      bottom: '0',
      containLabel: true,
    },
    xAxis: [
      {
        type: 'category',
        data: hour24Trend.value?.xAxis ?? [],
        axisLine: {
          show: true,
          lineStyle: { color: 'rgba(255,255,255,.1)', width: 1, type: 'solid' },
        },
        axisTick: { show: false },
        axisLabel: {
          interval: 0,
          show: true,
          splitNumber: 5,
          textStyle: { color: 'rgba(255,255,255,.6)', fontSize: '12' },
        },
      },
    ],
    yAxis: [
      {
        type: 'value',
        axisLabel: {
          show: true,
          textStyle: { color: 'rgba(255,255,255,.6)', fontSize: '12' },
        },
        axisTick: { show: false },
        axisLine: {
          show: true,
          lineStyle: { color: 'rgba(255,255,255,.1)', width: 1, type: 'solid' },
        },
        splitLine: {
          show: false,
          lineStyle: { color: 'rgba(255,255,255,.1)' },
        },
      },
    ],
    series: [
      {
        type: 'line',
        data: hour24Trend.value?.data ?? [],
        itemStyle: {
          normal: { color: '#2f89cf', opacity: 1, barBorderRadius: 5 },
        },
      },
    ],
  }
  sysxChart.value.setOption(option)
}

async function initAreaEchart() {
  // This chart uses #map_1, which is not in the current template.
  // Add <div id="map_1" style="width: 600px; height: 400px;"></div> to template if needed.
  const chartDom = document.getElementById('map_1')
  if (!chartDom) {
    console.warn("Element with id 'map_1' not found for area_echarts.")
    return
  }
  const myChart = echarts.init(chartDom)
  charts.push(myChart)

  try {
    // Assuming 44.json is in public/js/44.json or adjust path
    const response = await fetch('./js/44.json') // Adjust path as needed
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)
    const tjJson = await response.json()

    echarts.registerMap('guangdong', tjJson)
    myChart.setOption({ series: [{ type: 'map', map: 'guangdong' }] })

    const geoCoordMap: Record<string, [number, number]> = {
      珠海市: [113.353986, 21.924979],
      广州市: [113.480637, 23.125178],
      // ... (rest of geoCoordMap from area_echarts.js)
      惠州市: [114.412599, 23.079404],
    }
    const goData = [
      { name: '河源市', value: 32 },
      { name: '湛江市', value: 24 },
      // ... (rest of goData)
      { name: '揭阳市', value: 18 },
    ]
    let goTotal = 0
    goData.forEach((item) => (goTotal += item.value))

    const planePath = 'arrow'
    const convertData = (name: string, data: { name: string; value: number }[]) => {
      const res = []
      const fromCoord = geoCoordMap[name]
      for (let i = 0; i < data.length; i++) {
        const toCoord = geoCoordMap[data[i].name]
        if (fromCoord && toCoord) {
          res.push({ coords: [fromCoord, toCoord] })
        }
      }
      return res
    }

    const series: any[] = []
    ;[['广州市', goData]].forEach((item: [string, any[]]) => {
      series.push(
        {
          name: item[0],
          type: 'lines',
          zlevel: 2,
          effect: {
            show: true,
            period: 6,
            trailLength: 0.1,
            symbol: planePath,
            symbolSize: 10,
          },
          lineStyle: {
            normal: {
              width: 1,
              opacity: 0.4,
              curveness: 0.2,
              color: 'rgba(255,255,255,.1)',
            },
          },
          data: convertData(item[0], item[1]),
        },
        {
          name: item[0],
          type: 'scatter',
          coordinateSystem: 'geo',
          zlevel: 2,
          label: {
            normal: {
              show: false,
              color: 'rgba(255,255,255,.5)',
              position: 'right',
              formatter: '{b}',
            },
          },
          symbol: 'circle',
          symbolSize: (val: any[]) => (val[2] * 50) / goTotal,
          itemStyle: { normal: { show: true } },
          data: item[1].map((dataItem) => ({
            name: dataItem.name,
            value: geoCoordMap[dataItem.name].concat([dataItem.value]),
          })),
        },
        {
          name: item[0],
          type: 'scatter',
          coordinateSystem: 'geo',
          zlevel: 2,
          label: {
            normal: { show: true, position: 'right', formatter: '{b}' },
          },
          symbolSize: () => 15,
          symbol: 'circle',
          itemStyle: { normal: { show: true } },
          data: [{ name: item[0], value: geoCoordMap[item[0]].concat([100]) }],
        },
      )
    })

    const option: EChartsOption = {
      title: {
        text: '业务覆盖',
        subtext: '2016-2018年数据',
        left: 'center',
        bottom: '15%',
        textStyle: { color: '#fff' },
      },
      tooltip: { trigger: 'item', formatter: '{b}' },
      visualMap: { show: false, min: 0, max: 100, color: ['#fff'] as any },
      geo: {
        map: 'guangdong',
        zoom: 1,
        label: {
          normal: { show: true, textStyle: { color: 'rgba(255,255,255,.3)' } },
          emphasis: { textStyle: { color: '#fff' } },
        },
        roam: false,
        itemStyle: {
          normal: { areaColor: '#4256ff', borderColor: '#404a59' },
          emphasis: { areaColor: '#2539f5' },
        },
      },
      series: series,
    }
    myChart.setOption(option)
  } catch (error) {
    console.error('Failed to load or process area_echarts data:', error)
  }
}

function initTagCloud() {
  // Ensure Bubble.js (tagcloud function) is loaded globally or imported.
  // Example: if (typeof tagcloud === 'function') { ... }
  // For this example, assuming tagcloud is available.
  // You might need to install a Vue-specific tag cloud library or integrate Bubble.js properly.
  if (typeof (window as any).tagcloud === 'function') {
    ;(window as any).tagcloud({
      selector: '.tagcloud',
      fontsize: 6,
      radius: 40,
      mspeed: 'slow',
      ispeed: 'slow',
      direction: 0,
      keep: false,
    })
  } else {
    console.warn('tagcloud function not found. Please ensure Bubble.js is loaded.')
  }
}

function handleResize() {
  charts.forEach((chart) => chart.resize())
}

onMounted(async () => {
  updateTime()

  // Wait for the next DOM update cycle before initializing charts
  await nextTick()

  initEchart1()
  initMap()
  initEchart3_4()
  initFbCharts()
  initMyd1Chart()
  initSysxChart()
  // initAreaEchart() // Uncomment if #map_1 is added to template
  // initTagCloud()

  // moveTagCloud()

  window.addEventListener('resize', handleResize)
})

// Cleanup on unmount
onUnmounted(() => {
  if (timeUpdateTimeout) clearTimeout(timeUpdateTimeout)
  window.removeEventListener('resize', handleResize)
  charts.forEach((chart) => chart.dispose())
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showDigits.value, (digit, idx) => {
          return (_openBlock(), _createElementBlock("span", {
            key: idx,
            class: "flip-card"
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["flip-card-inner", { flipping: flipFlags.value[idx] }]),
              onTransitionend: ($event: any) => (onFlipEnd(idx))
            }, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(showDigits.value[idx]), 1),
              _createElementVNode("span", _hoisted_8, _toDisplayString(nextDigits.value[idx]), 1)
            ], 42, _hoisted_6)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("ul", _hoisted_10, [
        _createElementVNode("li", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("table", _hoisted_15, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(stationList), (station, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, "No." + _toDisplayString(index + 1), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_16, _toDisplayString(station.stationName), 1)
                      ]),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", _hoisted_17, _toDisplayString(station.totalElec) + "KW.h", 1)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("ul", _hoisted_23, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(totalEvseStatus), (evseStatusTotal) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: evseStatusTotal.name
                    }, [
                      _createElementVNode("span", null, _toDisplayString(evseStatusTotal.name), 1),
                      _createElementVNode("p", null, _toDisplayString(evseStatusTotal.value), 1)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(totalListData), (total) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: total.label
                    }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", null, _toDisplayString(total.label), 1),
                        _createElementVNode("p", null, _toDisplayString(total.value), 1),
                        _createElementVNode("span", null, _toDisplayString(total.unit), 1)
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _hoisted_31,
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("ul", _hoisted_33, [
                      _createElementVNode("li", null, [
                        _hoisted_34,
                        _createElementVNode("p", null, _toDisplayString(_unref(hour24Total)?.totalOrderNum ?? 0), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_35,
                        _createElementVNode("p", null, _toDisplayString(_unref(hour24Total)?.totalElec ?? 0), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_36,
                        _createElementVNode("p", null, _toDisplayString(_unref(hour24Total)?.totalElecAmount ?? 0), 1)
                      ]),
                      _createElementVNode("li", null, [
                        _hoisted_37,
                        _createElementVNode("p", null, _toDisplayString(_unref(hour24Total)?.totalServiceAmount ?? 0), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _hoisted_38
            ])
          ])
        ]),
        _createElementVNode("li", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createElementVNode("div", _hoisted_45, _toDisplayString(_unref(userStat).totalNum), 1)
              ]),
              _hoisted_46
            ])
          ]),
          _createElementVNode("div", _hoisted_47, [
            _hoisted_48,
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _createElementVNode("div", _hoisted_52, _toDisplayString(_unref(co2EmissionReductionValue)) + "摩尔", 1)
              ]),
              _createElementVNode("div", _hoisted_53, [
                _hoisted_54,
                _createElementVNode("div", _hoisted_55, _toDisplayString(_unref(plantingTreeValue)) + "棵", 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_56, [
        _createElementVNode("ul", _hoisted_57, [
          _hoisted_58,
          _createElementVNode("li", _hoisted_59, [
            _hoisted_60,
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("div", _hoisted_62, [
                _hoisted_63,
                _createElementVNode("div", _hoisted_64, _toDisplayString(_unref(yesterdayTotal)?.totalAmount ?? 0), 1),
                _createElementVNode("div", {
                  class: _normalizeClass(["parcent", { green: _unref(parcent).totalAmount > 0 }])
                }, [
                  _hoisted_65,
                  _createElementVNode("span", null, _toDisplayString(_unref(parcent).totalAmount == 0 ? '' : _unref(parcent).totalAmount > 0 ? '+' : '') + _toDisplayString(_unref(parcent).totalAmount) + "%", 1)
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_66, [
                _hoisted_67,
                _createElementVNode("div", _hoisted_68, _toDisplayString(Math.abs((_unref(yesterdayTotal)?.totalChargingTime ?? 0) / 3600).toFixed(2)), 1),
                _createElementVNode("div", {
                  class: _normalizeClass(["parcent", { green: _unref(parcent).totalChargingTime > 0 }])
                }, [
                  _hoisted_69,
                  _createElementVNode("span", null, _toDisplayString(_unref(parcent).totalChargingTime == 0
                        ? ''
                        : _unref(parcent).totalChargingTime > 0
                        ? '+'
                        : '') + _toDisplayString(_unref(parcent).totalChargingTime) + "%", 1)
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_70, [
                _hoisted_71,
                _createElementVNode("div", _hoisted_72, _toDisplayString(_unref(yesterdayTotal)?.totalElec ?? 0), 1),
                _createElementVNode("div", {
                  class: _normalizeClass(["parcent", { green: _unref(parcent).totalElec > 0 }])
                }, [
                  _hoisted_73,
                  _createElementVNode("span", null, _toDisplayString(_unref(parcent).totalElec == 0 ? '' : _unref(parcent).totalElec > 0 ? '+' : '') + _toDisplayString(_unref(parcent).totalElec) + "%", 1)
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_74, [
                _hoisted_75,
                _createElementVNode("div", _hoisted_76, _toDisplayString(_unref(yesterdayTotal)?.totalOrderNum ?? 0), 1),
                _createElementVNode("div", {
                  class: _normalizeClass(["parcent", { green: _unref(parcent).totalOrderNum > 0 }])
                }, [
                  _hoisted_77,
                  _createElementVNode("span", null, _toDisplayString(_unref(parcent).totalOrderNum == 0 ? '' : _unref(parcent).totalOrderNum > 0 ? '+' : '') + _toDisplayString(_unref(parcent).totalOrderNum) + "%", 1)
                ], 2)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})